import { render, staticRenderFns } from "./WagonLabeling.vue?vue&type=template&id=addb1290&scoped=true"
import script from "./WagonLabeling.vue?vue&type=script&lang=js"
export * from "./WagonLabeling.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "addb1290",
  null
  
)

export default component.exports